module.exports = __webpack_public_path__ + "img/keshihua.e073baea.jpg";